// extracted by mini-css-extract-plugin
export default {"btn":"Orders_btn__LrQ2P","table":"Orders_table__Rt+lr","lead":"Orders_lead__vQlXd"};